import { render, staticRenderFns } from "./VoiceToVoice.vue?vue&type=template&id=aed0463e&"
import script from "./VoiceToVoice.vue?vue&type=script&lang=js&"
export * from "./VoiceToVoice.vue?vue&type=script&lang=js&"
import style0 from "./VoiceToVoice.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VoiceToVoice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports